import axios from "axios";
import {STATION_API} from "../../config";
import Cache from "../cache";

async function findAll() {
    const cachedStations = await Cache.get("AdminStations");
    //if(cachedStations) return cachedStations;
    return axios
        .get(STATION_API)
        .then(response => {
            const stations = response.data.stations;
            Cache.set("AdminStations", stations);
            return stations;
        });
}


async function find(id){

    const cachedStations = await Cache.get("AdminStations." + id);
    //if(cachedStations) return cachedStations;
    return axios.get(STATION_API + "/" + id)
        .then(response => {
            const station = response.data.station;
            Cache.set("AdminStations." + id, station);
            return station;
        });
}


function deleteStation(id) {

    return axios
        .delete(STATION_API + "/" + id)
        .then(async response => {
            const cachedStations = await Cache.get("stations");

            if(cachedStations){
                Cache.set("AdminStations", cachedStations.filter(i => i.id != id));
            }

            return response;
        });
}

function updateStation(id, station){

    return axios.post(STATION_API + "/store", {...station, id: id})
        .then(async response => {

            // const cachedStations = await Cache.get("AdminStations");
            //
            // const cachedPV = await Cache.get("AdminStations." + id);
            //
            // if(cachedPV){
            //     Cache.set("AdminStations." + id, response.data.station);
            // }
            //
            // if(cachedStations){
            //     const index = cachedStations.findIndex(b => b.id === +id);
            //     cachedStations[index] = response.data.station;
            // }

            return response;
        });
}

function create(station){

    return axios.post(STATION_API + "/store", station)
        .then(async response => {
            const cachedStations = await Cache.get("AdminStations");

            // if(cachedStations){
            //     Cache.set("AdminStations", [...cachedStations, response.data.station]);
            // }

            return response;
        });
}

export default {
    findAll,
    find,
    create,
    updateStation,
    delete : deleteStation,
};